import { StatusChip } from 'components/Chips/StatusChip'
import { selectReportStatusColor } from './selectReportStatusColor'

import type { ReportStatus } from 'features/yieldbirdWrapperAgent/api/types'

type Props = {
  status: ReportStatus
}

export const ReportStatusChip = ({ status }: Props): React.JSX.Element => (
  <StatusChip
    chipColors={(theme, chipStatus) => selectReportStatusColor(chipStatus, theme)}
    status={status}
  />
)
